module.exports = __webpack_public_path__ + "static/media/ic_close_black.334eeeb6.svg";